import { render } from "./AutogenView.vue?vue&type=template&id=12b58db0&scoped=true"
import script from "./AutogenView.vue?vue&type=script&lang=js"
export * from "./AutogenView.vue?vue&type=script&lang=js"

import "./AutogenView.vue?vue&type=style&index=0&id=12b58db0&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b58db0"]])

export default __exports__